export default "__VITE_ASSET__6d4591bf__"